module.exports = __webpack_public_path__ + "img/49-image-1@2x.f5a238d0.png";